import { createContext } from 'react';
import Keycloak from 'keycloak-js';
import { IUser, IUserScope } from 'interfaces/User';

/** Sin perfil no se supone nada: ni alcance ni capacidades. */
export const EMPTY_SCOPE: IUserScope = {
	mode: 'none',
	can_operate: false,
	can_audit: false,
	dependencies: []
};

export interface AuthContextData {
	keycloak: Keycloak;
	user?: IUser;
	loading: boolean;
	isAuthorized: boolean;
	/** Roles de la aplicación de la persona: el del perfil del backend y, sin perfil, el que deduce el token. */
	roles: string[];
	/** Alcance y capacidades que decide el backend. Las pantallas lo leen en lugar de mirar el nombre del rol. */
	scope: IUserScope;
	login?: (credentials: any, callback: () => void) => void;
	logout?: () => void;
}

export const AuthContext = createContext<AuthContextData>({
	loading: true,
	isAuthorized: false,
	roles: [] as string[],
	scope: EMPTY_SCOPE
} as AuthContextData);
